@if (isUpgradeCandidate) {
  <div class="setup-costs-headline">
    {{ 'cartridge.setUpCostsNotApplicable' | transloco }}
  </div>
} @else {
  <div class="setup-costs-headline">
    {{ 'cartridge.setUpCosts' | transloco }}
  </div>
  <div class="setup-costs">
    {{
      setUpCosts.centAmount / 100
        | currency: setUpCosts.currency : 'symbol' : '1.0-2'
    }}
    <span class="vat">{{ 'cartridge.priceExcludingVAT' | transloco }}</span>
  </div>
}
